<div>
  <app-modal [isActive]="true" [isLarge]="true" [showCloseFooter]="false" [showClose]="false">
    <p class="center-text" modal-title></p>
    <div class="center-text" modal-content>
      <p>{{ 'auth.end-session.unavailable' | translate }}</p>
      <p>{{ 'auth.end-session.close-window' | translate }}</p>
    </div>
  </app-modal>
</div>
